<div class="d-flex align-items-center" data-tour="app-branding">
  @if(!mini()) {
    <a [routerLink]="['/']" class="logo-full">
      <img src="./assets/images/logos/f4rm-logo-text.png" class="align-middle m-2 logolight" alt="logo" width="140"
        height="44" />
      <img src="./assets/images/logos/f4rm-logo-text-inverted.png" class="align-middle m-2 logodark" alt="logo"
        width="140" height="44" />
    </a>
  }

  <a [routerLink]="['/']" class="logo-alt" [class.mini-only]="mini()">
    <img src="./assets/images/logos/f4rm-logo.png" class="align-middle m-2 logolight" alt="logo" width="40"
      height="40" />
    <img src="./assets/images/logos/f4rm-logo-inverted.png" class="align-middle m-2 logodark" alt="logo" width="40"
      height="40" />
  </a>
</div>